module.exports = __webpack_public_path__ + "static/media/pepper-hot.fc4bdeee.svg";